import { UiElement } from '../../ui/UiElement.js';
import { saveAsFile } from '../../utils/utils.js';

export { ScreenshotButton };

/**
 * Simple button to open the layer legend overview
 *
 * @author rhess <robin.hess@awi.de>
 * 
 * @memberof vef.map
 */
class ScreenshotButton extends UiElement {

    constructor(map, position) {
        super();

        this.map = map;
        this.position = position || "top-left";
        this.initButton_();

        this.map.addTool(this, this.position);
    }

    initButton_() {
        // initialize element
        const element = this.getElement();
        element.classList.add("vef-tool");
        element.title = "Save current map as image";

        const icon = document.createElement("i");
        icon.className = "fas fa-camera";
        element.appendChild(icon);

        let processing = false;
        element.addEventListener("click", () => {
            if (processing) return;
            processing = true;

            // start spinning
            icon.className = "fas fa-spinner fa-spin fa-fw";

            html2canvas(this.map.mapContainer_, {
                allowTaint: true,
                useCORS: true
            }).then(canvas => {
                    canvas.toBlob(blob => {
                        saveAsFile(blob, "viewer.png");
                    }, 'image/png');
                }).finally(() => {
                    // end spinning
                    processing = false;
                    icon.className = "fas fa-camera";
                });
        });
    }
}